import { Component, OnInit } from '@angular/core';
import { debounceTime } from 'rxjs/operators';
import { Alert, AlertType } from '../../model/alert.model';
import { AlertService } from '../../services/message.service';

/**
 * * Componente de alertas (mensageria) do Apolo.
 */
@Component({
  selector: 'ui-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss']
})
export class AlertComponent implements OnInit {

  /**
   * * Array de alertas.
   */
  alerts: Alert[] = [];

  constructor(private alertService: AlertService) { }

  ngOnInit(): void {
    this.alertService.alert.subscribe(alert => {
        if (!alert) {
            // clear alerts when an empty alert is received
            this.alerts = [];
        } else {
          // add alert to array
          this.alerts.push(alert);
        }
    });

    this.alertService.alert.pipe(
      debounceTime(7000)
    ).subscribe(() => this.alertService.clear());
  }

  /**
   * * Remover alerta.
   * @param alert Alerta.
   */
  removeAlert(alert: Alert): void {
      this.alerts = this.alerts.filter(x => x !== alert);
  }

  /**
   * * Definição do css a partir do Alerta.
   * @param alert Alerta
   * @returns Classe css a ser aplicada.
   */
  cssClass(alert: Alert): string | undefined {
    if (!alert) {
        return;
    }

    // return css class based on alert type
    switch (alert.type) {
        case AlertType.Success:
            return 'success';
        case AlertType.Error:
            return 'error';
        case AlertType.Info:
            return 'info';
        case AlertType.Warning:
            return 'warning';
    }
  }

  /**
   * * Definição do ícone css a partir do Alerta.
   * @param alert Alerta
   * @returns Classe de ícone css a ser aplicada.
   */
  iconCssClass(alert: Alert): string {
    if (!alert) {
        return '';
    }

    // return css class based on alert type
    switch (alert.type) {
      case AlertType.Success:
          return 'fa-check-circle';
      case AlertType.Error:
          return 'fa-times-circle';
      case AlertType.Info:
          return 'fa-info-circle';
      case AlertType.Warning:
          return 'fa-exclamation-triangle';
    }
  }

}
